import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from './ebi.jpg';
import './App.css';
import flexibleSearch from './assets/searching.js';
import PriorityQueue from './assets/priorityQueue.js';
import { grabData } from "./assets/dataUploader";
import VoiceSearchButton from './assets/VoiceSearchButton.js';

function App() {

  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState({});
  const navigate = useNavigate();
  const numResults = 8;

  useEffect(() => {
    const getData = async () => {
      grabData().then(
        data => {
          setData(data);
          window.sessionStorage.setItem("database", JSON.stringify(data));
        }
      ).then(
        _ => {setLoaded(true)}
      )
    }

    if (!loaded){
      getData();
    }
  });

  const [searchVal, setSearchVal] = useState('');

  const handleButtonClick = (char) => {
    setSearchVal((prev) => prev + char);
  };

  const handleInputChange = (event) => {
    setSearchVal(event.target.value);
  };

  const handleVoiceResult = (result) => {
    setSearchVal(result);
    handleSearch(result, false);
  }

  const handleSearch = (query, english) => {

    const topResults = new PriorityQueue((a, b) => b.score - a.score);

    //Handle reloading
    if (Object.keys(data).length === 0){
      if (window.sessionStorage.getItem("database") !== undefined){
        setData(JSON.parse(window.sessionStorage.getItem("database")));
        setLoaded(true);
      }
    }
    if(loaded){
      Object.keys(data).forEach((topic) => {
        //Look through the array of word objects
        data[topic].forEach((wordObj) => {
          //Need to calculate the proximity score for each object
          const score = 
            flexibleSearch(query, wordObj[english ? 'english_1' : 'yoruba_1']) * 3 +
            flexibleSearch(query, wordObj[english ? 'english_2' : 'yoruba_2']) +
            flexibleSearch(query, wordObj[english ? 'english_3' : 'yoruba_3']) +
            flexibleSearch(query, wordObj[english ? 'e_sentence' : 'y_sentence']) * 0.8 +
            flexibleSearch(query, wordObj['speech']) * 0.1;

          topResults.enqueue({wordObj, score});

          if (topResults.size() > numResults) {
            topResults.dequeue();
          }
        });
      });

      let closest = [];
      while (!topResults.isEmpty()) {
          const item = topResults.dequeue(); // Reverse the order to maintain original order
          console.log(item);
          closest.push(item.wordObj);
      }

      closest = closest.reverse();

      window.sessionStorage.setItem("query", query);
      window.sessionStorage.setItem("searchType", english? "english": "yoruba");
      window.sessionStorage.setItem("results", JSON.stringify(closest));
      navigate("query");
    }else{
      setTimeout(() => {
        handleSearch(query, english);
      }, 3000);
    }
  }

  const specialCharacters = ['à', 'á', 'è', 'é', 'ì', 'í', 'ò', 'ó', 'ù', 'ú', 'ẹ̀', 'ẹ', 'ẹ́', 'ọ̀', 'ọ', 'ọ́', 'ṣ'];

  return (
    <div id="screen" className="Home">
      <header className="App-header">
        <h3>The Yoruba Dictionary</h3>

        <img src={logo} className="App-logo" alt="logo" />
        
        <p style={{marginTop:'2em'}}>Looking to translate a word?</p>
        <div className='search-area'>
          <VoiceSearchButton onResult={handleVoiceResult}/>
          <input className="search-val" value={searchVal} onChange={handleInputChange} />
          <Link className='search-button' onClick={() => handleSearch(searchVal, true)}>English To Yoruba!</Link>
          <Link className='search-button' onClick={() => handleSearch(searchVal, false)}>Yoruba To English!</Link>
        </div>
        
        <div className="special-characters">
          {specialCharacters.map((char, index) => (
            <button
              key={index}
              className="char-button"
              onClick={() => handleButtonClick(char)}
            >
              {char}
            </button>
          ))}
        </div>
      </header>
    </div>
  );
}

export default App;
